import BannerBlock from './BannerBlock/BannerBlock'
import TeamGridBlock from './TeamGridBlock/TeamGridBlock'

import style from './teampage.module.scss'

const TeamPage = () => {
    return (
        <div className={style.teampage}>
            <BannerBlock />
            <TeamGridBlock />
        </div>
    )
}

export default TeamPage